import { useState, useEffect } from "react";
import washday from "../../Assets/Images/washday.jpg";
import open_defec from "../../Assets/Images/open defecation.png";
import disaster from "../../Assets/Images/disaster fight in rural area.png";
import toilet_conf from "../../Assets/Images/bangladesh toilet conference.jpg";
import river_water from "../../Assets/Images/river water.jpg";
import { useTranslation } from "react-i18next";
import { formatDateByLang } from "../../Utils/covertDate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";

const NEWS_LIST = [
  {
    id: 1,
    title: "new_home.news_title_1",
    category: "news",
    text: "new_home.news_description_1",
    photo: washday,
    date: "28 NOV 2024",
  },
  {
    id: 2,
    title: "new_home.news_title_2",
    category: "news",
    text: "new_home.news_description_2",
    photo: river_water,
    date: "28 NOV 2024",
  },
  {
    id: 3,
    title: "new_home.news_title_3",
    category: "news",
    text: "new_home.news_description_3",
    photo: toilet_conf,
    date: "28 NOV 2024",
  },
  {
    id: 4,
    title: "new_home.news_title_4",
    category: "news",
    text: "new_home.news_description_4",
    photo: open_defec,
    date: "28 NOV 2024",
  },
  {
    id: 5,
    title: "new_home.news_title_5",
    category: "news",
    text: "new_home.news_description_5",
    photo: disaster,
    date: "28 NOV 2024",
  },
];

const getSlidesPerView = (width) => {
  if (width < 768) return 1;
  if (width < 1024) return 2;
  return 3;
};

const NewsSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slidesPerView, setSlidesPerView] = useState(
    getSlidesPerView(window.innerWidth)
  );

  useEffect(() => {
    const handleResize = () => {
      setSlidesPerView(getSlidesPerView(window.innerWidth));
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? NEWS_LIST.length - slidesPerView : prev - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev >= NEWS_LIST.length - slidesPerView ? 0 : prev + 1
    );
  };

  const visibleItems = NEWS_LIST.slice(
    currentIndex,
    currentIndex + slidesPerView
  ).concat(
    currentIndex + slidesPerView > NEWS_LIST.length
      ? NEWS_LIST.slice(0, currentIndex + slidesPerView - NEWS_LIST.length)
      : []
  );
  const { t, i18n } = useTranslation();
  return (
    <div className="w-full py-8 px-4 md:px-8 relative mt-4">
      <h2 className="text-[28px] md:text-[32px] lg:text-[36px] font-bold pb-4">
        {t("new_home.news_and_update")}
      </h2>
      <div className="flex items-center justify-center gap-2">
        <button
          onClick={handlePrev}
          className="text-gray-600 hover:text-black disabled:opacity-50 rounded-full bg-gray-400 opacity-40 size-8 2xl:size-16 hover:scale-105"
        >
         <FontAwesomeIcon icon={faChevronLeft} size="lg" />  
        </button>

        <div className="flex gap-6 overflow-hidden justify-center  px-2">
          {visibleItems.map((item) => (
            <div
              key={item.id}
              className="text-left  max-w-[350px] w-full bg-[#2F4B7C] text-white rounded-lg overflow-hidden shadow-md flex flex-col"
            >
              <img
                src={item.photo}
                alt={t(item.title)}
                className="w-full h-48 object-cover"
              />
              <div className="p-4 flex flex-col flex-grow">
                <p className="text-xs uppercase opacity-80 mb-1 font-mono tracking-wider">
                  {item.category}
                </p>
                <h3 className="text-lg font-semibold mb-2">{t(item.title)}</h3>
                <p className="text-sm opacity-80 mb-4">{t(item.text)}</p>
                <p className="text-xs mt-auto text-right opacity-70 text-gray-300 font-mono">
                  {formatDateByLang(item.date, i18n.language)}
                </p>
              </div>
            </div>
          ))}
        </div>

        <button
          onClick={handleNext}
          className="text-gray-600 hover:text-black disabled:opacity-50 rounded-full bg-gray-400 opacity-40 size-8 2xl:size-16 hover:scale-105"
        >
        <FontAwesomeIcon icon={faChevronRight} size="lg" />  
        </button>
      </div>

      {/* <div className="mt-6 text-center">
        <button className="px-4 py-2 border border-[#2F4B7C] text-[#2F4B7C] rounded hover:bg-[#2F4B7C] hover:text-white transition">
          Explore
        </button>
      </div> */}
    </div>
  );
};

export default NewsSlider;
